<template>
  <div>
    <BaseTable
      :headers="fields"
      :items="items"
      tableClasses="item-table border"
      responsive
      hide-default-footer
      fixed-header
      ref="baseTable"
      height="200"
    >
    </BaseTable>
  </div>
</template>

<script>
export default {
  name: 'MerchantCategoryComponent',
  props: {
    items: {
      type: Array,
    },
    fields: Array,
  },
};
</script>
<style scoped>
.fieldset-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 33px;
  color: #006298;
  text-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
}
</style>
